import * as $http from 'axios'

export default {
    all: () => $http.get('v2/premium_survey_questions'),
    myAnswer: () => $http.get('v2/premium_survey_results'),
    post: payload => $http.post('v2/premium_survey_results', payload),
}
